// Email Configuration Constants

// Validation limits
export const REMINDERS_LIMITS = {
    RENT: { MIN: 1, MAX: 99 },
    PAYMENT: { MIN: 1, MAX: 99 }
};

// Error messages
export const ERROR_MESSAGES = {
    DAYS_RANGE: 'Days must be between {MIN} and {MAX}',
    MIN_DAYS_RANGE: 'Value must be at least {MIN}',
    NO_VENDOR: 'Please select a vendor to configure email settings.',
    AUTO_APPROVE_REQUIRED: 'Auto approve is required when final reminder is set.',
    AUTO_APPROVE_DAYS_REQUIRED: 'Number of days is required when auto approve is enabled',
    BRAND_REQUIRED: 'At least one brand must be selected.',
    SECOND_REMINDER_SEQUENCE: 'Value of 2nd reminder should be greater than 1st reminder',
    FINAL_REMINDER_SEQUENCE: 'Value of final reminder should be greater than 2nd reminder',
    FINAL_REMINDER_SEQUENCE_FIRST: 'Value of final reminder should be greater than 1st reminder',
    NO_BUSINESS_UNIT: 'Please select a business unit to configure email settings.',
    NO_VENDOR_AUTOMATION_SETTINGS: 'Please select a vendor to configure automation settings.',
    NO_BUSINESS_UNIT_AUTOMATION_SETTINGS: 'Please select a business unit to configure automation settings.',
};

export const SUCCESS_MESSAGES = {
    VENDOR_CONFIGURATION_UPDATE: 'Vendor configuration updated successfully.',
    BRAND_CONFIGURATION_UPDATE: 'Brand configuration updated successfully.',
};

// Section titles
export const SECTION_TITLES = {
    EMAIL_REMINDERS: 'E-mail reminders',
    PAYMENT_REMINDERS: 'Payment receipt reminders'
};

// Input fields
export const INPUT_FIELDS = {
    RENT_REMINDER: {
        ID: 'rentReminderDays',
        LABEL: 'Rent almost over reminders',
        PLACEHOLDER: 'Enter number of days',
        DESCRIPTION: 'Number of days prior to end of rental.'
    },
    PAYMENT_REMINDERS: {
        FIRST: {
            ID: 'firstReminderDays',
            LABEL: 'First reminder',
            PLACEHOLDER: 'Enter number of days'
        },
        SECOND: {
            ID: 'secondReminderDays',
            LABEL: 'Second reminder',
            PLACEHOLDER: 'Enter number of days'
        },
        FINAL: {
            ID: 'thirdReminderDays',
            LABEL: 'Final reminder',
            PLACEHOLDER: 'Enter number of days'
        },
        SHARED_DESCRIPTION: 'Number of days after original request.'
    },
    AUTO_APPROVE: {
        CHECKBOX: {
            ID: 'autoApproveCheck',
            NAME: 'autoApproveEnabled',
            LABEL: 'Automatically approve modification after final reminder',
            DESCRIPTION: 'Enable automatic approval of requests after the final reminder has been sent.'
        },
        WAITING_PERIOD: {
            ID: 'autoApproveAfterDays',
            PLACEHOLDER: 'Enter number of days',
        }
    }
};

// Default settings values
export const DEFAULT_SETTINGS = {
    rentReminderDays: 1,
    firstReminderDays: undefined,
    secondReminderDays: undefined,
    thirdReminderDays: undefined,
    autoApproveAfterDays: undefined,
    autoApproveEnabled: false,
    brandIds: []
};